/**
 * @fileoverview added by tsickle
 * Generated from: models/instruction.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { defineModelProperties, model } from '../util/model';
/** @enum {string} */
var InstructionLimitType = {
    All: "all",
    Visit: "visit",
    Until: "until",
};
export { InstructionLimitType };
/**
 * Model representing an instruction from the Customer to their Housekeeper.
 * Each instruction may be linked to a particular task type.
 * @record
 */
function BaseInstruction() { }
if (false) {
    /** @type {?} */
    BaseInstruction.prototype.id;
    /** @type {?} */
    BaseInstruction.prototype.appliesUntil;
    /** @type {?} */
    BaseInstruction.prototype.instruction;
    /** @type {?|undefined} */
    BaseInstruction.prototype.order;
    /** @type {?|undefined} */
    BaseInstruction.prototype.taskType;
    /** @type {?} */
    BaseInstruction.prototype.visitRecord;
}
/**
 * @record
 */
function InstructionModelMixin() { }
if (false) {
    /** @type {?} */
    InstructionModelMixin.prototype.limitType;
}
/**
 * @record
 */
export function Instruction() { }
/** @type {?} */
export var instruction = model.extend((/** @type {?} */ ({
    modelName: 'instruction'
})));
defineModelProperties(instruction, {
    limitType: {
        get: /**
         * @return {?}
         */
        function () {
            if (this.appliesUntil) {
                return InstructionLimitType.Until;
            }
            if (this.visitRecord) {
                return InstructionLimitType.Visit;
            }
            return InstructionLimitType.All;
        }
    }
});
